package com.merkost.handpass.api.dto.user

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class PublicProfileResponse(
    val id: String,
    @SerialName("full_name") val fullName: String = "",
    @SerialName("avatar_url") val avatarUrl: String? = null,
    @SerialName("phone_verified") val phoneVerified: Boolean = false,
    val bio: String? = null,
    val city: String? = null,
    val country: String? = null,
    val rating: Double? = null,
    @SerialName("total_sales") val totalSales: Int = 0,
    @SerialName("total_purchases") val totalPurchases: Int = 0,
    @SerialName("is_verified") val isVerified: Boolean = false,
    @SerialName("created_at") val createdAt: String? = null,
    val slug: String? = null,
)
